import {
  getUsersEmail,
  getUsersGivenName,
  getUsersFamilyName
} from 'web/src/shared/Auth'

export const QUOTE_USE_MODES = {
  WHOLE_SCHOOL_DISTRICT: 'school_district',
  WHOLE_SCHOOL: 'school',
  CLASSROOM: 'classroom',
  OTHER: 'other'
}

export const QUOTE_HANDLING_VALUES = {
  FORMAL_QUOTE: 'formal_quote',
  ORGANISE_A_CALL: 'organise_a_call',
  LICENSE_RENEWAL: 'license_renewal'
}

export const MOTE_AMBITION_MODES = {
  SETUP_SCHOOL_30_DAYS: 'setup_school_in_30_days',
  SETUP_SCHOOL_60_TO_90_DAYS: 'setup_school_in_60_to_90_days',
  NEXT_SCHOOL_YEAR: 'next_school_year',
  NONE: 'none'
}

export const QUOTE_FORM_ERROR_MESSAGE = {
  stringTypeError: 'Please enter a value containing at least 1 character',
  numberTypeError: 'Please enter a valid numeric value',
  quantityMinError: 'Please enter a quantity totaling more than 10',
  quantityNegativeError:
    'Please enter a quantity greater than or equal to zero',
  termLengthError: 'Please select a term length',
  otherUseError: 'Please enter a description',
  firstNameError: 'Please enter your first name',
  lastNameError: 'Please enter your last name',
  institutionError: 'Please enter your organization name',
  emailError: 'Please enter a valid organizational email address',
  googleMailError: 'Please use an organizational email address',
  phoneError: "Please enter a phone that's at least 5 digits long",
  countryCodeError: 'Please select a country',
  regionError: 'Please enter or select a region',
  quoteHandlingError: 'Please select at least one'
}

export const DEFAULT_QUOTE_FORM_VALUES = {
  quoteUse: QUOTE_USE_MODES.WHOLE_SCHOOL_DISTRICT,
  facultyLicenseQuantity: '',
  studentLicenseQuantity: '',
  totalQuantity: '',
  termLength: '',
  PDHours: 0,
  otherUseDescription: '',
  firstName: getUsersGivenName(),
  lastName: getUsersFamilyName(),
  institutionName: '',
  enquirerEmail: getUsersEmail(),
  phoneNumber: '',
  countryCode: 'us',
  region: '',
  quoteHandling: [],
  moteAmbition: MOTE_AMBITION_MODES.SETUP_SCHOOL_30_DAYS,
  additionalInfo: ''
}
